import { render, staticRenderFns } from "./CaseNotification.vue?vue&type=template&id=75c321ed&lang=pug"
import script from "./CaseNotification.vue?vue&type=script&lang=ts"
export * from "./CaseNotification.vue?vue&type=script&lang=ts"
import style0 from "./CaseNotification.vue?vue&type=style&index=0&id=75c321ed&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CaseNotification.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FComponents%2FNotification%2FCaseNotification.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports